import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import BrandValues from './components/BrandValues';
import MissionSection from './components/MissionSection';
import Testimonials from './components/Testimonials';
import FaqSection from './components/FaqSection';
import CtaBanner from './components/CtaBanner';

export default function AboutPage() {
  useSEO({
    title: 'About Daliah Secret | Our Brand Story, Values & Mission',
    description:
      'Discover the story behind Daliah Secret — a luxury perfume and hair oil brand rooted in nature, artisan craftsmanship, and sustainable beauty. Learn about our values, mission, and commitment to pure natural ingredients.',
    keywords:
      'Daliah Secret about, brand story, luxury perfume brand, natural hair oils, sustainable beauty, artisan craftsmanship',
    canonical: '/about',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <AboutHero />
      <BrandStory />
      <BrandValues />
      <MissionSection />
      <Testimonials />
      <FaqSection />
      <CtaBanner />
      <Footer />
    </div>
  );
}
